var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomizedScalable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 0H5.40979V24.1123H31.8579V50.4166H5.40979V50.4167H55V0Z",
    fill: "#256BE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1558 10.0809C46.1471 10.0327 46.1312 9.98778 46.1189 9.94125C46.1045 9.88573 46.0929 9.83022 46.0734 9.77633C46.0532 9.72163 46.0257 9.67183 46.0005 9.61958C45.9802 9.57795 45.9643 9.53468 45.9405 9.49467C45.8343 9.31588 45.6985 9.16158 45.5396 9.04238C45.5056 9.01626 45.4681 8.99911 45.4327 8.97625C45.3857 8.94686 45.3409 8.91502 45.2911 8.89216C45.2441 8.87012 45.195 8.85787 45.1466 8.84154C45.1047 8.82766 45.065 8.8097 45.0216 8.79991C44.9284 8.77868 44.8338 8.76807 44.7385 8.76807H31.0474C30.2499 8.76807 29.6026 9.49957 29.6026 10.4009C29.6026 11.3022 30.2499 12.0337 31.0474 12.0337H41.2523L22.363 33.3812C21.7988 34.0188 21.7988 35.0524 22.363 35.69C22.6447 36.0092 23.0146 36.1684 23.3844 36.1684C23.7543 36.1684 24.1242 36.0092 24.4059 35.69L43.2944 14.3425V25.8759C43.2944 26.7773 43.9417 27.5088 44.7392 27.5088C45.5367 27.5088 46.1839 26.7773 46.1839 25.8759V10.4009C46.1847 10.2939 46.1745 10.187 46.1558 10.0809Z",
    fill: "#020845",
    stroke: "#020845"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 30.8877,
    width: 24.2441,
    height: 24.1123,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizedScalable);
export default __webpack_public_path__ + "static/media/customized-scalable.0d0b23416ede5c4a4b44a4beeba88e74.svg";
export { ForwardRef as ReactComponent };